{
  "instances": {
    "threaddump": {
      "label": "Дамп потоков",
      "download": "Загрузить дамп потоков",
      "download_failed": "Ошибка при загрузке дампа потоков.",
      "thread_details_blocked_count": "Количество блокировок",
      "thread_details_blocked_time": "Время блокировки",
      "thread_details_lock_name": "Имя блокировки",
      "thread_details_lock_owner_id": "Идентификатор владельца блокировки",
      "thread_details_lock_owner_name": "Имя владельца блокировки",
      "thread_details_waited_count": "Количество ожиданий",
      "thread_details_waited_time": "Время ожиданий",
      "thread_id": "Идентификатор потока",
      "thread_name": "Имя потока",
      "thread_state": "Статс потока"
    }
  }
}
